import DashboardLayout from '../layouts/DashboardLayout'

export const allotmentMenu = {
  path: '/allotment',
  component: DashboardLayout,
  name: 'Allotment',
  children: [
    {
      path: 'list',
      component: () => import (/* webpackChunkName: "about" */'../pages/allotment-contact/allotment-list/AllotmentList'),
      meta: {
        roles: ['allotment-contact_read', 'allotment-contact_update'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Danh sách lộ trình'
        }]
      },
    },
    {
      path: 'struct',
      component: () => import (/* webpackChunkName: "about" */'../pages/allotment-contact/allotment-structure/AllotmentSetting'),
      meta: {
        roles: ['setting-contact_read', 'setting-contact_update'],
        requiresAuth: true,
        breadcrumb: [{
          title: 'Cơ cấu phân bổ'
        }]
      }
    }
  ],
}